import { createRouter, createWebHistory } from 'vue-router'
import { isLoggedIn } from '@/api/auth'

const routes = [
  { path: '/', redirect: '/dashboard' },
  { path: '/login', component: () => import('@/pages/Login.vue'), meta: { public: true } },
  { path: '/dashboard', component: () => import('@/pages/Dashboard.vue') },
  { path: '/platform', component: () => import('@/pages/PlatformList.vue') },
  { path: '/play-env', redirect: '/platform' },
  { path: '/catalog', component: () => import('@/pages/CatalogList.vue') },
  { path: '/catalog/:id', component: () => import('@/pages/CatalogDetail.vue') },
  { path: '/snapshot/:id', component: () => import('@/pages/SnapshotDetail.vue') },
  { path: '/inventory', component: () => import('@/pages/Inventory.vue') },
  { path: '/bios', component: () => import('@/pages/Bios.vue') },
  { path: '/acquisition', component: () => import('@/pages/AcquisitionList.vue') },
  { path: '/drive', component: () => import('@/pages/Drive.vue') },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  if (to.meta.public) return true
  if (!isLoggedIn()) {
    return { path: '/login', query: { next: to.fullPath } }
  }
  return true
})

export default router
